import { Line } from "react-chartjs-2";
import BoxWithShadow from "../../common/components/BoxWithShadow";
import { formatDate } from "../../../utilities/format";
import { useGetNetworkGraphDashboardAsAdminQuery } from "../../../lib/apollo/graphql/generated";
import Loader from "../../common/components/Loader";
import { MonthlyPeriod } from "global";

const getChartLabels = (year: number, month: number) => {
  const last = new Date(`${year}-${month}-01`);

  return Array.from({ length: 12 }).map((_, index) => {
    const date = new Date(last.getFullYear(), last.getMonth() - 11 + index, 1);

    return formatDate(date.toISOString(), "YYYY.MM");
  });
};

interface NetworkTrendChartBoxProps {
  period: MonthlyPeriod;
}

export default function NetworkTrendChartBox({
  period,
}: NetworkTrendChartBoxProps) {
  const { data, loading } = useGetNetworkGraphDashboardAsAdminQuery({
    variables: {
      ...period,
    },
  });

  const trend = data?.getNetworkGraphDashboardAsAdmin;
  const labels = getChartLabels(period.year, period.month);

  const invitors = labels.map((label) => {
    const [fullYear, mm] = label.split(".").map(Number);

    const found = trend?.find(
      (item) => Number(item.year) === fullYear && Number(item.month) === mm
    );

    return found ? found.totalInviteUserCount : 0;
  });

  const invitees = labels.map((label) => {
    const [fullYear, mm] = label.split(".").map(Number);

    const found = trend?.find(
      (item) => Number(item.year) === fullYear && Number(item.month) === mm
    );

    return found ? found.totalInvitedUserCount : 0;
  });

  if (loading) {
    return (
      <BoxWithShadow className="gap-3">
        <p className="text-lg font-bold">추천 네트워크 추이</p>
        <Loader />
      </BoxWithShadow>
    );
  }

  return (
    <BoxWithShadow className="gap-3">
      <p className="text-lg font-bold">추천 네트워크 추이</p>
      <div className="h-full px-5">
        <Line
          data={{
            labels,
            datasets: [
              {
                label: "추천인 수",
                data: invitors,
                borderColor: "rgb(75, 192, 192)",
                backgroundColor: "rgba(75, 192, 192, 0.5)",
                tension: 0.3,
                pointHoverRadius: 10,
              },
              {
                label: "피추천인 수",
                data: invitees,
                borderColor: "rgb(226, 118, 64)",
                backgroundColor: "rgba(162, 75, 32, 0.5)",
                tension: 0.3,
                pointHoverRadius: 10,
              },
            ],
          }}
          options={{
            scales: {
              x: {
                grid: {
                  display: false,
                },
              },
              y: {
                min: 0,
                beginAtZero: true,
              },
            },
            maintainAspectRatio: false,
            responsive: true,
            plugins: {
              legend: {
                position: "bottom",
              },
            },
          }}
        />
      </div>
    </BoxWithShadow>
  );
}
